module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    attrs: {
      "id": "resources"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: " panel-body bg-white pl-0 pr-0"
  }, [(_vm.resources && _vm.resources.length > 0) ? _c('table', {
    staticClass: "table text-center",
    attrs: {
      "id": "booking-resources"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("input.type")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("input.received_at")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("button.actions")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.resources), function(resource) {
    return _c('tr', [_c('td', [_vm._v("\n            " + _vm._s(_vm.getResourceName(resource.type)) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(_vm.getReceivedDate(resource.created_at)) + "\n          ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "d-flex align-items-center justify-content-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openViewDocumentModal(resource)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("booking.detail.resources.view_document")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeResource(resource.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.delete")))])])])])])])])])])
  }))]) : _c('div', {
    staticClass: "pl-5 pt-10"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("booking.detail.resources.no_resource")) + "\n      ")])])]), _vm._v(" "), _c('v-view-document-modal', {
    attrs: {
      "resource": _vm.resource
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af75ce7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/bookings/details/Resources.vue
// module id = 1427
// module chunks = 0